import React, { useContext } from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import MobileRow from 'app/src/components/Orders/MobileRow';
import { columns as orderColumns } from 'app/src/components/Orders';
import ClientContext from 'app/src/contexts/ClientContext';
import mobileTable from 'app/src/elements/Table/MobileTable';
import SimpleTable from 'app/src/elements/Table/Simple';
import { Title, Text } from 'app/src/styles';
import { ActionText } from 'app/src/styles/table';
import { Link } from 'app/src/utils/routing';

import { ORDERS } from './queries';

const columns = [...orderColumns.slice(1)];
columns[0] = { ...columns[0], sort: 'desc' };

const DealerOrders = ({ orders, title, isMobile }) => {
  const { currentUser } = useContext(ClientContext);

  const { t } = useTranslation();

  if (currentUser.isEmployee) {
    columns[columns.length - 1].hidden = false;
  }

  columns[columns.length - 2].content = ({ entry }) => (
    <Link to={`/orders/${entry.id}/tags`}>
      <ActionText>{t('actions.viewTags')}</ActionText>
    </Link>
  );

  return (
    <View>
      <Title>{title || 'Orders'}</Title>

      <SimpleTable
        pageLength={10}
        data={orders}
        columns={columns}
        component={isMobile ? mobileTable : null}
        componentProps={{ rowComponent: MobileRow, currentUser }}
      />
    </View>
  );
};

export default DealerOrders;
